module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "title": "选择渠道",
      "width": "70%",
      "append-to-body": ""
    },
    on: {
      "close": _vm.handleCancel
    }
  }, [_c('div', {
    style: ({
      maxHeight: '400px',
      overflowY: 'auto'
    })
  }, _vm._l((_vm.groupChannelOptions), function(group) {
    return _c('div', {
      key: group.brand + '-' + group.category,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-bottom": "8px"
      }
    }, [_vm._v("\n        " + _vm._s(group.label) + "\n      ")]), _vm._v(" "), _c('el-checkbox-group', {
      model: {
        value: (_vm.localValue),
        callback: function($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue"
      }
    }, _vm._l((group.options), function(item) {
      return _c('el-checkbox', {
        key: item.productChannelCode,
        attrs: {
          "label": item.productChannelCode
        }
      }, [_vm._v(_vm._s(item.productChannelName))])
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1240f83b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/ProductChannelDialog.vue
// module id = 2410
// module chunks = 68